<template>
    <div class="col-lg-4 card-deck mb-4 " v-loading="loading">
        <div class="card">
            <div class="card-favorite">
                <a class="active" href="javascritp:;" @click="likeToggle"><i :class="likeClass"></i></a>
            </div>
            <img class="card-img-top" :src="thumbImage" alt="Card image cap">
            <div class="card-body">
                <h5 class="card-title">{{title}}</h5>
                <p class="text-right mb-0"><a :href="url" class="link-more">Learn more <i class="icon-arrow-right"></i></a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import helpers from './../../components/Helpers';

    export default {
        mixins: [helpers],
        mounted() {
            this.thumbImage = this.imgPath || this.getFallBackImage();
            this.like = this.initialLike
        },
        props: {
            resourceId: {
                required: true,
            },
            imgUrl: {
                required: false,
                default: null
            },
            title: {
                required: true,
                default: ""
            },
            url: {
                required: true,
                default: "#"
            },
            type: {
                required: true,
                // 0 recommended 1 favorite jobs 2 favorite resource
            },
            initialLike: {
                default: true,
            }
        },
        data() {
            return {
                like: true,
                thumbImage: "",
                loading: false,
            }
        },
        computed: {
            likeClass() {
                return this.like ? "fas fa-heart" : "far fa-heart"
            },
            routes() {
                return [
                    {
                        like: window.App.routes.api.jobs_like,
                        dislike: window.App.routes.api.jobs_dislike
                    },
                    {
                        like: window.App.routes.api.jobs_like,
                        dislike: window.App.routes.api.jobs_dislike
                    },
                    {
                        like: window.App.routes.api.resources_like,
                        dislike: window.App.routes.api.resources_dislike
                    }
                ]
            },
            likePayload() {
                return [
                    {
                        job: this.resourceId
                    },
                    {
                        job: this.resourceId
                    },
                    {
                        resource: this.resourceId
                    },

                ]
            },
            imgPath() {
                let imageURL = this.imgUrl !== null
                    ? this.imgUrl[0] === '/'
                        ? window.location.protocol + '//' +window.location.hostname + this.imgUrl
                        : this.imgUrl
                    : null;
                // console.log(imageURL)
                return imageURL ? new URL(imageURL).pathname : null;
            }
        },
        methods: {
            likeToggle() {
                this.loading = true;
                let callSetting = {
                    method: "post",
                    route: this.routes[this.type].like,
                }
                if (this.like) {
                    callSetting.method = "put";
                    callSetting.route = this.routes[this.type].dislike;
                }
                axios({
                    method: callSetting.method,
                    url: callSetting.route,
                    data: this.likePayload[this.type]
                }).then((response) => {
                    this.like = !this.like;
                    this.loading = false;
                }).catch(e => console.log(e));
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/my_profile/ItemCard.vue